import styled from 'styled-components'

export const OurPhilosophyContainer = styled.div`
    display: grid;
    grid-template-columns: 50% 50%;
    color: white;
    padding: 100px 200px 30px 200px;
    max-width: 1500px;
    margin: 0 auto;

    @media (max-width: 550px) {
      /* Phones */
       grid-template-columns: 1fr;
       padding: 100px 30px;
    }

    @media (max-width: 1100px) {
        /* Tablets */
        grid-template-columns: 1fr;
        padding: 100px 30px;
    }
`

export const ImagePhilosophy = styled.div`
    width: 100%;
`

export const TextPhilosophy = styled.div`
    h1{
        text-transform: uppercase;
        margin-top: 24px;
        margin-bottom: 24px;
    }

    p{
        text-align: justify;
    }
`